import React from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import parse from 'html-react-parser';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {
    AppDispatch,
    StoreState
} from '~/frontend/src/store';
import {clearAlertMessage} from '~/frontend/src/actions/message/clearAlertMessage';

const AlertMessage = () => {
    const dispatch     = useDispatch<AppDispatch>(),
          alertMessage = useSelector( ( state : StoreState ) => state.alertMessage ),
          footer       = (
              <div>
                  <Button label="OK" className="p-button-outlined" onClick={() => dispatch( clearAlertMessage() )}/>
              </div>
          );

    if ( alertMessage ) {
        let className : string = 'yn-info-dialog';

        switch ( alertMessage.severity ) {
            case 'error':
                className = 'yn-error-dialog';
                break;
            case 'warning':
                className = 'yn-warning-dialog';
                break;
        }

        return <Dialog
            header={alertMessage.title}
            footer={footer}
            appendTo={null}
            visible={true}
            closable={false}
            className={className}
            onHide={() => {
            }}>
            {parse( alertMessage.message )}
        </Dialog>;
    }
    else {
        return null;
    }
}

export default AlertMessage;
